import React from 'react';
import { useLocation } from 'react-router';

export const useQuery = () => {
  const { search } = useLocation();
  const a = useLocation();
  console.log(a);
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
